import Vendor from 'src/vendor.config';
import { extractTheme } from '../utils/themer';

export type IColor =
	| 'action'
	| 'actionSecondary'
	| 'background'
	| 'backgroundSecondary'
	| 'backgroundTertiary'
	| 'text'
	| 'textSecondary'
	| 'textAction';

/**
 * Hexadecimal, string-formed colors-code collection.
 * NOTE: Color objects ought not be complex and so must not be nested.
 */
export const Color = {
	ACTION: extractTheme(Vendor.gui.color.action),
	ACTION_SECONDARY: extractTheme(Vendor.gui.color.actionSecondary),
	BACKGROUND: extractTheme(Vendor.gui.color.background),
	BACKGROUND_LIGHT: extractTheme(Vendor.gui.color.backgroundLight),
	BACKGROUND_SECONDARY: extractTheme(Vendor.gui.color.backgroundSecondary),
	BACKGROUND_TERTIARY: extractTheme(Vendor.gui.color.backgroundTertiary),
	BACKGROUND_ACCENT: extractTheme(Vendor.gui.color.backgroundAccent),
	TEXT: extractTheme(Vendor.gui.color.text),
	TEXT_SECONDARY: extractTheme(Vendor.gui.color.textSecondary),
	TEXT_ACTION: extractTheme(Vendor.gui.color.textAction),

	// todo eliminate
	BACKGROUND_DARK: extractTheme(Vendor.gui.color.backgroundSecondary),
	TEXT_BLACK: extractTheme(Vendor.gui.color.textSecondary),
	TEXT_BLACK_LIGHT: extractTheme(Vendor.gui.color.backgroundSecondary),
	TEXT_WHITE: extractTheme(Vendor.gui.color.text),

	// todo eliminate
	TEXT_GRAY: '#646E83',
	GRAPH_GREEN: '#6AAD38',
	GRAPH_RED: '#FF3F3F',
	BORDER: '#FFFFFFF1A',
	BORDER_TABLE_LIGHT: '#F1F3F6',
	SHADOW: '#0000000D',
	TEST_GREEN: '#0b7a0b',
	GRAY_BORDER_LIGHT: '#4E4F52',
};
